import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { updateCTNNo } from './redux';

const propTypes = {
  selectedSalesOrder: PropTypes.object
}

const defaultProps = {
  selectedSalesOrder: {},
}

export class CtnEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ctnNo: props.selectedSalesOrder.ctnNo,
    };
  }
  handleSubmitClick = () => {
    const {
      selectedSalesOrder: {
        SalesOrder_id,
      },
      handleCTNNoUpdateSuccess
    } = this.props;
    const {
      ctnNo
    } = this.state;
    const payload = {
      salesOrderId: SalesOrder_id,
      CTNNo: ctnNo,
    };
    updateCTNNo(payload, handleCTNNoUpdateSuccess);
  }
  render() {
    const {
      ctnNo,
    } = this.state;
    return (
      <div>
        <Row style={{ marginBottom: "12px" }}>
          <Col sm={3}>
            <label style={{ float: 'right' }}>
              <Translate value="container_no" />:
            </label>
          </Col>
          <Col sm={7}>
            <Input 
              type="string"
              value={ctnNo}
              onChange={(e) => {
                this.setState({ ctnNo: e.target.value })
              }}
            />
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: "50px" }}>
          <Button
            bsStyle="success"
            onClick={this.handleSubmitClick}
            disabled={!ctnNo}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

CtnEditModal.propTypes = propTypes
CtnEditModal.defaultProps = defaultProps

export default CtnEditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ctnEdit/CtnEditModal.jsx